/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_Isdefaultteam2Inputs */

const en_entity_isdefaultteam2 = /** @type {(inputs: Entity_Isdefaultteam2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Is Default Team`)
};

const de_entity_isdefaultteam2 = /** @type {(inputs: Entity_Isdefaultteam2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ist Standardteam`)
};

/**
* | output |
* | --- |
* | "Is Default Team" |
*
* @param {Entity_Isdefaultteam2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const entity_isdefaultteam2 = /** @type {((inputs?: Entity_Isdefaultteam2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_Isdefaultteam2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_isdefaultteam2(inputs)
	return de_entity_isdefaultteam2(inputs)
});
export { entity_isdefaultteam2 as "entity_isDefaultTeam" }